/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBoxPlotHorizontal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 2v18h18v2H2V2zm4 16H6v-6h2v2h2v-3h8v3h2v-2h2v6h-2v-2h-2v3h-8v-3H8zm8-5h-1v4h1zm-3 0h-1v4h1zm5-11v3h2V3h2v6h-2V7h-2v3h-8V7H8v2H6V3h2v2h2V2zm-2 2h-1v4h1zm-3 0h-1v4h1z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBoxPlotHorizontal as ChartBoxPlotHorizontal };
